import { IconButton } from '@/components/ui/icon-button'
import { DarkMode } from '@components'
import { SearchTrigger } from '@features/GlobalSearch'
import Notifications from '@features/Notifications'
import { useLocation } from '@solidjs/router'
import { useAuth } from '@stateApp'
import { LogOut } from 'lucide-solid'
import { Show, createMemo, createSignal, onMount } from 'solid-js'
import { useService } from 'solid-services'
import { when } from 'src/core/breakpoints'
import { css, cva } from 'styled-system/css'
import { Box, Flex, Grid } from 'styled-system/jsx'
import { scrollbar } from 'styled-system/recipes'
import Logo from './Logo'
import { RouteSelector } from './RouteSelector'
import SideBar from './SideBar'

const compactSize = 40
const heroSize = 60

// Accent placeholder — swap to your Panda token or CSS var
const accent = 'hsl(268 90% 60%)' // <-- change me later

const glow = cva({
  base: {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none',
  },
})

const glowDot = css({
  width: `${heroSize * 1.4}px`,
  height: `${heroSize * 1.4}px`,
  borderRadius: '999px',
  filter: 'blur(20px)',
  background:
    'radial-gradient(60% 60% at 50% 50%, var(--colors-tsc-green-default)  0%, transparent 70%)',
  opacity: 0.18,
})

export const Desktop = () => {
  const { logout } = useService(useAuth)()

  // Reduced motion
  const [rm, setRm] = createSignal(false)
  onMount(() => {
    const m = window.matchMedia?.('(prefers-reduced-motion: reduce)')
    setRm(!!m?.matches)
    m?.addEventListener?.('change', (e) => setRm(e.matches))
  })

  return (
    <Grid
      class={scrollbar()}
      p={3}
      borderRight='solid 1px var(--colors-bg-surface)'
      borderColor='bg.surface'
      justifyContent="space-between"
      justifyItems='center'
      gridTemplateRows='1fr auto'
      height='calc(var(--vh) * 100)'
      overflowY='auto'
    >
      <RouteSelector />

      <Grid gap='1'>
        <SideBar />
        <DarkMode />
        <IconButton
          onClick={logout}
          size="sm"
          color='fg.subtle'
          variant="plain"
        >
          <LogOut />
        </IconButton>
      </Grid>

    </Grid>
  )
}


export const Mobile = () => {
  const location = useLocation()
  const isHome = createMemo(() => location.pathname === '/')
  const { logout, isSuper } = useService(useAuth)()

  // Reduced motion
  const [rm, setRm] = createSignal(false)
  onMount(() => {
    const m = window.matchMedia?.('(prefers-reduced-motion: reduce)')
    setRm(!!m?.matches)
    m?.addEventListener?.('change', (e) => setRm(e.matches))
  })

  return (
    <Flex
      py={1.5}
      px={3}
      justifyContent="space-between"
      alignItems='center'
    >
      <Logo isSmall />

      <Flex gap='1'>
        <SearchTrigger tooltipPlacement='bottom' />
        <Notifications />
        <SideBar />
      </Flex>

    </Flex>
  )
}


export default function () {

  return (
    <Show
      when={when.smDown()}
      fallback={<Desktop />}
    >
      <Mobile />
    </Show>
  )
}


